import TitleLead from '../../atoms/TitleLead';
import * as generalHelper from '../../../helpers/generalHelper';
import { CreatePatient } from '../../../store/types';
import { fullName } from '../../../helpers/nameHelper'

const PatientInformation = ({ patientData }: Partial<CreatePatient>) => {
  return (
    <div className="row border bg-white m-2 mb-3 pb-3">
      <div className="col-sm-12 d-flex flex-column px-3">
        <TitleLead className="ml-2 my-3" label={generalHelper.t('PATIENT INFORMATION')} />
        <hr className="w-100 mt-0" />
      </div>

      <div className="col-sm-12 ml-2">
        <div className="row">
          <div className="col-6 d-flex flex-column ml-1">
            <span className="font-weight-bold textGray">Patient Name</span>
            <span className="my-2">
              {fullName(patientData?.firstName, patientData?.lastName)}
              {patientData?.suffix && `, ${patientData?.suffix}`}
            </span>
          </div>
          <div className="col d-flex flex-column">
            <span className="font-weight-bold textGray">Date Of Birth</span>
            <span className="my-2">{patientData?.dob}</span>
          </div>

          <div className="col d-flex flex-column">
            <span className="font-weight-bold textGray">Gender</span>
            <span className="my-2">{patientData?.gender}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PatientInformation;